<template>
  <div class="date-range-block">
    <date-range-picker
      v-model="dateRange"
      opens="opens"
      :show-dropdowns="true"
      :locale-data="languages[lng]"
      :ranges="ranges"
      :auto-apply="true"
      @update="updateValue"
    >
      <template #input="picker" style="min-width: 350px">
        <div v-if="!picker.startDate && !picker.endDate" style="position: absolute; background: white; width: calc(100% - 20px); font-size: 14px">
          {{ 'Please select the date range' | i18n }}
        </div>
        {{ picker.startDate | date }} - {{ picker.endDate | date }}
      </template>
    </date-range-picker>
    <div class="clear" @click="clearRange">
      {{ 'Clear' | i18n }}
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import DateRangePicker from 'vue2-daterange-picker';
import { de, en } from 'vuejs-datepicker/dist/locale';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

let today = new Date();
today.setHours(0, 0, 0, 0);

let yesterday = new Date();
yesterday.setDate(today.getDate() - 1);
yesterday.setHours(0, 0, 0, 0);

let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

export default {
  name: 'DateRange',
  components: { DateRangePicker },
  filters: {
    date: function (value) {
      if (!value) return '';
      return moment(value).format('MMMM DD, YYYY');
    },
  },
  props: {
    update: {
      type: Function,
      default: () => {},
    },
    opens: {
      type: String,
      default: 'left',
    },
    startDate: {
      type: Date,
      default: null,
    },
    endDate: {
      type: Date,
      default: null,
    },
  },
  data: function () {
    return {
      dateRange: {
        startDate: this.startDate,
        endDate: this.endDate,
      },
      languages: {
        de: {
          daysOfWeek: de._days,
          monthNames: de._months,
        },
        en: {
          daysOfWeek: en._days,
          monthNames: en._months,
        },
      },
      ranges: {
        [this.$translate('Today')]: [today, today],
        [this.$translate('Yesterday')]: [yesterday, yesterday],
        [this.$translate('This month')]: [thisMonthStart, thisMonthEnd],
        [this.$translate('This year')]: [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
        [this.$translate('Last month')]: [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
      },
    };
  },
  methods: {
    clearRange() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.update({});
    },
    updateValue(value) {
      this.update(value);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .vue-daterange-picker {
  width: 100%;
}

::v-deep .vue-daterange-picker .form-control {
  height: 31px !important;
  padding-top: 4px;
  border-radius: 0.2rem;
  border: 1px solid #ced4da;
}

::v-deep .daterangepicker {
  top: 35px;
}

@media screen and (min-width: 768px) {
  ::v-deep .daterangepicker {
    min-width: 685px !important;
  }
}

.date-range-block {
  min-width: 350px;
  text-align: center;
  display: flex;
  align-items: center;
}

.clear {
  border: 1px solid #eee;
  padding: 4px 20px;
  margin-left: 5px;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  color: white;
  background: linear-gradient(#2260ff, #2260ff);
  font-size: 14px;
}
</style>
